var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.90b15787762be9687e645096e48c2487.svg#q';
                    var viewUrl = 'sprites.90b15787762be9687e645096e48c2487.svg#view-q';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 15 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };